'use es6';

export default {
  FREE: 'FREE',
  PAID: 'PAID'
};